import { MeterGroupState } from './types';

const state = (): MeterGroupState => {
  return {
    meterGroups: [],
  };
};

export default state;
